"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typestyle_1 = require("typestyle");

exports.flex = function (isUser) {
  return typestyle_1.style({
    display: "flex"
  }, {
    justifyContent: isUser ? "flex-end" : "flex-start"
  });
};